import { cn } from "@/common/helpers/utils";
import type { ReactNode } from "react";

export function KeyboardKey({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        "border-border bg-muted text-muted-foreground pointer-events-none inline-flex h-5 min-w-5 items-center",
        "justify-center rounded border px-1 font-sans text-[10px] font-medium tracking-normal select-none",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
